import LegalDocPage from '@/components/LegalDocPage';

const MarketplaceGuidelines = () => <LegalDocPage documentType="marketplace_guidelines" title="Marketplace Guidelines" />;

export default MarketplaceGuidelines;
